module.exports = __webpack_public_path__ + "static/media/t-kapela.eb2daedb.svg";